import { reactive } from "vue";
export const useInit = reactive({
  init: false,
  setInit(flag) {
    this.init = flag;
  },
  getInit() {
    return this.init;
  }
});
